import { gql } from '@/__generated__/gql';

export const SET_LOGGED_IN_USER_PASSWORD_MUTATION = gql(`
  mutation AuthSetUserPassword($data: SetUserPasswordInput!) {
    setUserPassword(data: $data)
  }
`);
